'use client'

import React, { useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { Spinner } from 'flowbite-react'
import { checkForAvailability } from './actions'

interface DynamicInputProps {
  recordId?: number | string
  initValue?: string
  errors?: string
  updateFormData: any
  setDataDuplicated?: any
  duplicatedErrorMessage?: string
  duplicateCheckingURL?: string
  debounceTimeout?: number
}

const DuplicateCheckingInput: React.FC<DynamicInputProps> = (
  {
    recordId,
    initValue,
    errors,
    updateFormData,
    setDataDuplicated,
    duplicatedErrorMessage,
    duplicateCheckingURL,
    debounceTimeout = 400,
  },
) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isDuplicated, setIsDuplicated] = useState(false)

  const handleSearchKeyword = useDebouncedCallback(async (term) => {
    setIsLoading(true)

    const isTitleAvailable = await checkForAvailability(
      term,
      duplicateCheckingURL,
      recordId
    )
    setIsLoading(false)
    setIsDuplicated(!isTitleAvailable)
    setDataDuplicated && setDataDuplicated(isTitleAvailable)

    updateFormData('title', term)
  }, debounceTimeout)

  return (
    <>
      <div className="relative">
        <input
          defaultValue={initValue || ''}
          onChange={(e) => handleSearchKeyword(e.target.value)}
          type="text"
          className={`${errors || isDuplicated
            ? 'border-red-600'
            : 'border-gray-300'}
            border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
          required
        />
        {
          isLoading && (
            <div className="absolute top-1/2 -translate-y-1/2 right-2">
              <Spinner />
            </div>
          )
        }
      </div>
      {
        isDuplicated && (
          <span className="mt-2 text-red-600 text-sm">
            {duplicatedErrorMessage || 'Input is duplicated'}
          </span>
        )
      }
    </>
  )
}
export default DuplicateCheckingInput
